// Shared 3-band risk helper (Master-Prompt Stage B). Dirk approved 80/60 on Oct 4, 2026.
// Uses the raw (unrounded) score: 79.95 => caution, 80.0 => healthy; 59.95 => high.
export const band = (score) =>
  score == null || score === "" || Number.isNaN(Number(score))
    ? null
    : Number(score) >= 80
    ? "healthy"
    : Number(score) >= 60
    ? "caution"
    : "high";

export const BAND_LABELS = { healthy: "Healthy", caution: "Caution", high: "High Risk" };

// Colours from design tokens A1 (WCAG-AA text contrast).
export const BAND_META = {
  healthy: { label: "Healthy", text: "#166534", bg: "#f0fdf4", line: "#bbf7d0", bar: "#16a34a" },
  caution: { label: "Caution", text: "#92400e", bg: "#fffbeb", line: "#fde68a", bar: "#d97706" },
  high: { label: "High Risk", text: "#991b1b", bg: "#fef2f2", line: "#fecaca", bar: "#dc2626" },
  no_data: { label: "No Data", text: "#475569", bg: "#f8fafc", line: "#e2e8f0", bar: "#cbd5e1" },
};

// Map a backend risk_level (3-band or legacy 5-level) to a band key, preferring the score.
export const bandFromRiskLevel = (riskLevel, score) => {
  if (score != null && score !== "" && !Number.isNaN(Number(score))) return band(score);
  const r = String(riskLevel || "").toLowerCase();
  if (["healthy"].includes(r)) return "healthy";
  if (["caution", "moderate risk", "moderate_risk"].includes(r)) return "caution";
  if (["high_risk", "high risk", "immediate corrective action needed", "immediate_attention"].includes(r)) return "high";
  return null;
};
